import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a343240"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "loginModal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-labelledby": "loginModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body auth-wrapper" }
const _hoisted_5 = { class: "auth-form-wrapper" }
const _hoisted_6 = { class: "modal-title mb-3" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "data-bs-target": "#loginModal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "mb-2 form-label"
}, " Please enter your email address to receive your login code. ", -1))
const _hoisted_11 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_12 = {
  for: "name",
  class: "mb-2 form-label"
}
const _hoisted_13 = {
  key: 4,
  class: "alert alert-danger mt-4",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.logo,
                  height: "35",
                  class: "pe-2"
                }, null, 8, _hoisted_7),
                _createTextVNode(" Sign in")
              ])
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_8, null, 512), [
              [_vShow, false]
            ]),
            (!_ctx.codeSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "mt-1 form-control",
                    id: "email",
                    placeholder: "Enter your E-Mail",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitEmail && _ctx.submitEmail(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.email]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.codeSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, [
                    _createTextVNode(" We have just sent you an activation code to your email address: "),
                    _createElementVNode("i", null, _toDisplayString(_ctx.email), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "mt-1 form-control",
                    id: "code",
                    placeholder: "Enter your Code",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitCode && _ctx.submitCode(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.code]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.codeSent)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "amplify-button amplify-button--primary amplify-field-group__control amplify-authenticator__font d-flex",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitCode && _ctx.submitCode(...args)))
                }, " Login "))
              : _createCommentVNode("", true),
            (!_ctx.codeSent)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "amplify-button amplify-button--primary amplify-field-group__control amplify-authenticator__font d-flex",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitEmail && _ctx.submitEmail(...args)))
                }, " Send E-Mail "))
              : _createCommentVNode("", true),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}